const EmptyState = ({ icon, title, subtitle, action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    <div className="mb-4 text-5xl opacity-40">{icon}</div>
    <h3 className="text-lg font-medium text-zinc-800 dark:text-zinc-200">{title}</h3>
    {subtitle && <p className="mt-2 max-w-md text-sm text-zinc-600 dark:text-zinc-500">{subtitle}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export default EmptyState;
